<template>
  <section id="cases" class="h25-section alt">
    <div class="h25-container">
      <div class="h25-sec-hd center">
        <div class="label">Cases</div><h2>落地案例</h2>
        <p>每个案例均由生态渠道伙伴引入终端客户，创势全权负责方案设计、产品交付与全周期运维保障</p>
      </div>
      <div class="filter-bar">
        <button v-for="f in filters" :key="f.key" :class="{active:activeFilter===f.key}" @click="activeFilter=f.key">{{ f.label }}</button>
      </div>
      <div v-for="group in filteredGroups" :key="group.title" class="case-group">
        <h3>{{ group.title }}</h3><p class="sub">{{ group.sub }}</p>
        <div class="case-grid">
          <div class="case-card" v-for="c in group.cases" :key="c.title">
            <div class="case-img" :class="c.imgFit ? 'case-img--'+c.imgFit : ''"><img :src="c.img" :alt="c.title" /></div>
            <div class="case-info">
              <p class="case-scene">{{ c.scene }}</p>
              <div class="meta"><span v-for="t in c.tags" :key="t">{{ t }}</span></div>
              <p class="line" v-for="(item,i) in c.details" :key="i"><strong>{{ item.label }}：</strong>{{ item.value }}</p>
              <div class="case-metric" v-if="c.metric">{{ c.metric }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name:'CasesSection',
  data(){return{
    activeFilter:'all',
    filters:[{key:'all',label:'全部案例'},{key:'gov',label:'政府'},{key:'park',label:'园区'},{key:'mfg',label:'制造'},{key:'ai',label:'AI能力'}],
    groups:[
      {key:'gov',title:'政府客户群',sub:'商务关系由合作伙伴维护，创势提供全套AI方案与交付',cases:[
        {title:'AI智能审批系统',img:require('@/assets/images/2026/sp.png'),scene:'政务场景 · 区级行政服务大厅',tags:['智慧政务','AI审批','OCR识别'],
         details:[{label:'引入伙伴',value:'深圳龙华区企业服务协会'},{label:'客户规模',value:'日均办件量800+，窗口人员20+人'},{label:'痛点',value:'审批材料种类繁多、窗口人工核验耗时、群众排队等待平均超40分钟。'},{label:'交付',value:'专项适配政务公文格式，打通"自助填报→智能识别→自动比对→秒级反馈"全流程。'}],
         metric:'审批效率提升65%，群众等待缩短至12分钟，年减少纸质材料8万份'},
        {title:'部门工作画像系统',img:require('@/assets/images/2026/bmhx.png'),scene:'政务场景 · 街道办事处',tags:['智慧政务','数据汇聚','诉求闭环'],
         details:[{label:'引入伙伴',value:'深圳某街道办事处合作运营商'},{label:'客户规模',value:'下辖12个社区，服务人口15万'},{label:'痛点',value:'各部门工作数据分散，考核评比依赖人工汇总；民生诉求处理流程不透明。'},{label:'交付',value:'搭建AI驱动部门工作画像平台，自动汇聚多源数据。接入12345热线，诉求智能分拨→进度追踪→办结评价全闭环。'}],
         metric:'诉求办结率72%→96%，考核数据实时生成，居民满意度提升28%'}
      ]},
      {key:'park',title:'园区客户群',sub:'面向产业园区运营方及入驻企业',cases:[
        {title:'AI安防与能耗管理',img:require('@/assets/images/2026/af.png'),scene:'园区场景 · 科技产业园区',tags:['智慧园区','AI安防','能耗管理'],imgFit:'cover',
         details:[{label:'引入伙伴',value:'深圳南山某产业园区运营公司'},{label:'客户规模',value:'入驻企业200+，日均人流量5000+，年电费超300万'},{label:'痛点',value:'传统安防依赖人工巡检，夜间盲区多、响应滞后；能耗数据分散无法精细管控。'},{label:'交付',value:'部署AI视觉分析+边缘计算，打通门禁、停车、能耗监测系统，异常自动推送物业手机，能耗数据可视化大屏呈现。'}],
         metric:'异常响应缩短至30秒，能耗同比下降18%，年节省电费约54万元'}
      ]},
      {key:'mfg',title:'制造 / 企业客户群',sub:'面向实体制造企业及连锁零售企业',cases:[
        {title:'AI安全生产管控平台',img:require('@/assets/images/2026/safe-guard.png'),scene:'制造业 · 精密电子元器件企业',tags:['智能制造','AI视觉','安全合规'],
         details:[{label:'引入伙伴',value:'深圳宝安区制造业数字化转型服务联盟'},{label:'客户规模',value:'员工600人，3条产线'},{label:'痛点',value:'产线人员违规操作频发（月均8起），安全台账人工统计耗时且易出错，安监部门多次提出整改要求。'},{label:'交付',value:'部署AI视觉识别系统覆盖3条产线关键工位，实现人员行为实时监测、违规自动抓拍告警、安全台账智能生成与合规归档。'}],
         metric:'违规操作下降90%，台账整理从3天缩短至2小时，一次性通过安监合规验收'},
        {title:'AI数据中台',img:require('@/assets/images/2026/b1.png'),scene:'企业服务 · 连锁零售企业',tags:['数据中台','智能报表','企微集成'],
         details:[{label:'引入伙伴',value:'深圳某企业微信服务商'},{label:'客户规模',value:'门店50+，员工800人'},{label:'痛点',value:'各门店销售数据分散在Excel中，管理层无法实时掌握经营状况；月度经营分析会前需3人花费5天手工汇总数据。'},{label:'交付',value:'搭建企业级数据中台，自动接入各门店POS与ERP数据，实现自然语言查数、智能报表自动生成、异常指标预警实时推送至企微。'}],
         metric:'数据分析效率提升80%，月度经营报告自动生成，异常响应缩短至1小时'}
      ]},
      {key:'ai',title:'AI 能力产品',sub:'创势互联自研AI产品体系，覆盖智能协作、专家团队、语音服务、MCP服务等核心能力',cases:[
        {title:'智能体协作平台',img:require('@/assets/images/2026/image1.png'),scene:'政务场景 · 龙岗区',tags:['智能体协作','政务数字化','多智能体'],
         details:[{label:'适用场景',value:'政府信息化项目全生命周期管理，涉及多部门协同、多流程串联的复杂政务场景。'},{label:'产品定位',value:'以"智能体协作"为核心，打破单点AI应用孤岛，实现多个AI智能体的动态编排、协同调度与数据互通。'},{label:'核心价值',value:'全面赋能"数字龙岗"高质量建设，提升政务项目协同效率与管理水平。'}],
         metric:'多智能体协同效率提升60%，项目全周期数据100%在线贯通'},
        {title:'AI 专家工作台',img:require('@/assets/images/2026/image2.png'),scene:'企业服务 · 通用场景',tags:['小易智能','AI专家','即插即用'],
         details:[{label:'适用场景',value:'企业需要快速部署AI能力但缺乏自研团队，希望在现有业务中嵌入智能专家支持。'},{label:'产品定位',value:'让智能体为企业的业务赋能，内置215个AI专家角色，覆盖10+业务领域，即插即用。'},{label:'核心价值',value:'企业无需从零训练AI模型，开箱即用，快速部署到实际业务场景中，降低AI应用门槛。'}],
         metric:'215个AI专家覆盖政府、园区、制造等10+领域，部署周期缩短至天级'},
        {title:'AI 专家团队',img:require('@/assets/images/2026/image3.png'),scene:'企业服务 · 协作场景',tags:['小易智能','专家团队','AI协作'],
         details:[{label:'适用场景',value:'企业需要多领域专家协同进行方案评审、决策推演、风险评估等复杂分析工作。'},{label:'产品定位',value:'可定制的AI专家团队，赋能企业各领域专家进行头脑风暴、模拟推演与AI团队化运作。'},{label:'核心价值',value:'让不同领域的AI专家协同工作，模拟真实团队讨论场景，提供多视角决策支持。'}],
         metric:'团队决策效率提升55%，多专家协同分析覆盖率达90%'},
        {title:'AI MCP 服务',img:require('@/assets/images/2026/image4.png'),scene:'企业服务 · 工具集成',tags:['小易智能','MCP服务','工具集成'],
         details:[{label:'适用场景',value:'AI专家需要调用企业现有业务系统（OA、ERP、CRM等）完成数据查询、流程发起等操作。'},{label:'产品定位',value:'AI专家的专业工具集，通过标准化的MCP协议接口，让AI专家能够调用各类业务工具完成工作任务。'},{label:'核心价值',value:'打通AI与业务系统的连接，支持自定义工具接入，实现AI驱动的自动化工作流。'}],
         metric:'工具集成效率提升70%，支持100+业务系统无缝对接'},
        {title:'AI 语音服务',img:require('@/assets/images/2026/image5.png'),scene:'企业服务 · 多模态交互',tags:['小易智能','语音服务','多模态'],
         details:[{label:'适用场景',value:'需要语音交互的业务场景，如智能客服语音导航、会议记录、现场语音指令操作等。'},{label:'产品定位',value:'打造AI专家的语音沟通能力，支持ASR语音识别与TTS语音合成，让人与AI的沟通更为自然便捷。'},{label:'核心价值',value:'支持多语言、多方言语音识别，实时语音交互，提升AI助手的易用性与覆盖场景。'}],
         metric:'语音识别准确率97%+，支持中英及粤语等方言识别'},
        {title:'AI售前咨询助手',img:require('@/assets/images/2026/image6.png'),scene:'企业服务 · 售前场景',tags:['小易智能','售前助手','知识库'],
         details:[{label:'适用场景',value:'售前团队需7×24小时响应客户咨询，标准化输出产品方案与技术应答内容。'},{label:'产品定位',value:'专为企业售前打造的AI专家，支持企业自定义业务讲解场景和知识库，智能解答客户问题。'},{label:'核心价值',value:'降低售前人力成本，标准化输出产品方案与应答话术，提升客户咨询响应速度和专业度。'}],
         metric:'售前响应效率提升80%，7×24小时在线，客户满意度提升35%'},
        {title:'智能体运行数据平台',img:require('@/assets/images/2026/image7.png'),scene:'企业管理 · 运营监控',tags:['AI能力平台','数据可视','运行监控'],
         details:[{label:'适用场景',value:'管理者需要实时了解各AI智能体的运行状态、工作效率与资源使用情况，持续优化AI团队运营。'},{label:'产品定位',value:'可视化的AI专家工作效率平台，实时展示各智能体的运行状态、任务处理量、响应时效等关键指标。'},{label:'核心价值',value:'帮助管理者直观了解AI团队的运作情况，发现效率瓶颈，优化资源配置决策。'}],
         metric:'AI运行效率可视化覆盖率100%，异常响应缩短至5分钟'},
        {title:'多智能体协作服务',img:require('@/assets/images/2026/image8.png'),scene:'企业服务 · 协同办公',tags:['AI能力平台','多智能体','飞书集成'],
         details:[{label:'适用场景',value:'企业需要AI智能体在飞书等协同平台中7×24小时在线，与人类团队混合协作完成工作。'},{label:'产品定位',value:'基于飞书的多智能体24小时协作服务，支持多个AI智能体在飞书工作群中协同完成任务。'},{label:'核心价值',value:'实现"人+AI"混合团队协作模式，AI智能体随时在线响应，提升团队整体生产力。'}],
         metric:'7×24小时不间断服务，团队整体产能提升45%'}
      ]}
    ]
  }},
  computed:{
    filteredGroups(){
      if(this.activeFilter==='all') return this.groups
      return this.groups.filter(g=>g.key===this.activeFilter)
    }
  }
}
</script>
<style scoped>
.filter-bar{display:flex;justify-content:center;gap:10px;flex-wrap:wrap;margin-bottom:36px}
.filter-bar button{padding:8px 22px;border:1px solid var(--h25-border);border-radius:20px;background:transparent;color:var(--h25-muted);font-size:13px;font-weight:500;cursor:pointer;transition:all .2s}
.filter-bar button.active,.filter-bar button:hover{background:var(--h25-accent);color:#fff;border-color:var(--h25-accent)}
.case-group{margin-bottom:48px}
.case-group h3{font-size:20px;font-weight:700;color:#333;margin-bottom:4px}
.sub{font-size:13px;color:#666;margin-bottom:24px}
.case-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(380px,1fr));gap:20px;align-items:stretch}
.case-card{background:#fff;border:1px solid #eee;border-radius:8px;overflow:hidden;transition:all .3s;display:flex;flex-direction:column}
.case-card:hover{border-color:var(--h25-accent);transform:translateY(-4px);box-shadow:0 12px 32px rgba(0,0,0,.08)}
.case-img{width:100%;height:180px;background:#f0f4f8;display:flex;align-items:center;justify-content:center;flex-shrink:0}
.case-img img{display:block;max-width:100%;max-height:100%;width:auto;height:auto;object-fit:contain}
.case-img--cover img{max-width:none;max-height:none;width:100%;height:100%;object-fit:cover}
.ph{font-size:14px;color:var(--h25-muted2);text-align:center;padding:20px}
.case-info{padding:24px;flex:1;display:flex;flex-direction:column}
.case-scene{font-size:12px;color:var(--h25-muted);margin-bottom:12px}
.meta{margin-bottom:14px;display:flex;gap:8px;flex-wrap:wrap}
.meta span{font-size:11px;padding:3px 10px;background:var(--h25-bg);color:var(--h25-muted);border-radius:10px;font-weight:500}
.line{margin-bottom:4px;font-size:13px;color:var(--h25-muted);line-height:1.9}
.line strong{color:var(--h25-text)}
.case-metric{margin-top:auto;padding:16px 18px;background:var(--h25-bg);border-radius:var(--h25-radius);font-weight:700;font-size:15px;color:var(--h25-accent);line-height:1.8;border-left:3px solid var(--h25-accent)}
</style>
